import { useState } from 'react';
import TranscriptSelectionTables from './TranscriptSelectionTables';
import TranscriptSelectionSideDrawer from './TranscriptSelectionSideDrawer';
import TranscriptSelectionHeader from './TranscriptSelectionHeader';

import { useTranscriptSelectionOutletContext } from '../hooks/useTranscriptSelectionOutletContext';

import './TranscriptSelection.css';

function TranscriptSelection() {
  const { workflowStatus } = useTranscriptSelectionOutletContext();

  const isFinalized = workflowStatus === 'TRANSCRIPT_SELECTION_FINALIZED';
  const [isSideDrawerOpen, setIsSideDrawerOpen] = useState(isFinalized);

  return (
    <>
      <div className="transcript-selection-side-drawer-tables-container">
        <div className="transcript-selection-header-tables-container main-content">
          <TranscriptSelectionHeader handleSideDrawerOpen={() => setIsSideDrawerOpen(!isSideDrawerOpen)} />
          <TranscriptSelectionTables isSideDrawerOpen={isSideDrawerOpen} />
        </div>
        <TranscriptSelectionSideDrawer isOpen={isSideDrawerOpen} handleClose={() => setIsSideDrawerOpen(false)} />
      </div>
    </>
  );
}

export default TranscriptSelection;

// const TranscriptSelectionWithData = () => {

//   const { transcriptSelectionSchool } = useSchools();

//   const WrappedComponent = withData({
//     WrappedComponent: TranscriptSelection,
//     fetchData: (eoaId: string, access_token: string) => getTranscriptSelectionSummary(eoaId, access_token, transcriptSelectionSchool),
//     errorMessage: 'Error occurred while fetching transcript selection summary data!',
//     options: {
//       dependencies: [transcriptSelectionSchool]
//     }
//   });

//   return <WrappedComponent />;
// };

// export default TranscriptSelectionWithData;
